{
  "appName": "21P-530a Interment Allowance",
  "entryName": "21p-530a-interment-allowance",
  "rootUrl": "/forms/21p-530a/submit-state-interment-allowance-request",
  "entryFile": "./app-entry.jsx",
  "url": "/forms/21p-530a/submit-state-interment-allowance-request",
  "productId": "9fab5bb1-b901-458e-a5fe-ec4242cdc492",
  "template": {
    "title": "Apply for a VA interment allowance for a state or tribal organization",
    "heading": "Apply for a VA interment allowance for a state or tribal organization",
    "layout": "page-react.html",
    "description": "Apply for reimbursement for providing a free interment plot for an eligible Veteran",
    "hideFormTitle": false,
    "includeBreadcrumbs": true
  }
}
